<template>
  <v-modal
    v-model="show"
    :prevent-click="false"
    :focus-retain="true"
    :confirm-action="false"
    :cancel-action="false"
    :close-action="true"
    :attach="attach"
    data-cy="sl-dialog"
    @confirm="confirm"
    @cancel="cancel"
  >
    <template #title>
      {{ title }}
    </template>

    {{ msg }}
  </v-modal>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    attach: {
      default: false
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    confirm() {
      // some code...
    },
    cancel(close) {
      // some code...
      close()
    }
  }
}
</script>

